"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./css/common.css");
require("./css/variables.css");
var _axios = _interopRequireDefault(require("axios"));
var _Loader = require("./Loader");
var _Helpers = require("./Helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PressRelease = /*#__PURE__*/(0, _react.lazy)(() => Promise.resolve().then(() => _interopRequireWildcard(require("./PressRelease"))));
function PressReleaseComponent(props) {
  const pressReleaseTitle = props.pressReleaseTitle ? props.pressReleaseTitle : "Press Release";
  const [pressReleaseList, setPressReleaseList] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    if (pressReleaseList.length === 0) {
      _axios.default.get(process.env.REACT_APP_PRESS_RELEASES).then(res => {
        const arrayWithLatestDates = (0, _Helpers.getSortedJsonWrtDates)(res.data);
        setPressReleaseList(arrayWithLatestDates);
      });
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "pavans-page"
  }, /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_Loader.Loader, null)
  }, /*#__PURE__*/_react.default.createElement(PressRelease, {
    pressReleaseTitle: pressReleaseTitle,
    pressReleaseList: pressReleaseList
  })));
}
var _default = exports.default = PressReleaseComponent;